export default {
  init() {
    // JavaScript to be fired on all pages
    $('.navbar-toggler').on('click', function(){
      $('#overlay').toggleClass('s-active');
    });

  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js